export default "__VITE_ASSET__CqA5WKmI__"